import { CalendarOutlined, UserOutlined } from "@ant-design/icons";
import { Spin, Tag } from "antd";
import moment from "moment";
import React from "react";
import { Activity, Loading } from "../../../helpers/shared-interfaces";
import { ItemClickProps } from "../GlobalFormModal";
import NoData from "../NoData";

type Props = {
  loading: Loading;
  handleRetry: () => void;
  customerInteractions: Activity[];
  onInteractionClick: (item: ItemClickProps) => void;
};

export default function CustomerInteractions({
  customerInteractions,
  loading,
  handleRetry,
  onInteractionClick,
}: Props): JSX.Element {
  return (
    <div className="global-results">
      {loading === Loading.INITIAL ? null : loading === Loading.LOADING ? (
        <div className="loading-container">
          <div className="loading-spinner">
            <Spin size="default" />
          </div>
        </div>
      ) : loading === Loading.ERROR ? (
        <div className="error-container">
          <p>Something went wrong</p>
          <button onClick={handleRetry}>Try again</button>
        </div>
      ) : customerInteractions.length === 0 ? (
        <div className="no-results">
          <NoData />
          <p>No Data</p>
        </div>
      ) : (
        customerInteractions.map((interaction) => (
          <div
            key={interaction.id}
            className="search-result"
            role="presentation"
            onClick={() =>
              onInteractionClick({
                id: interaction.customer?.id || "",
                type: "interaction",
                segment: "customers",
                data: interaction,
              })
            }
          >
            <div className="result-content">
              <div className="result-title">{interaction.description}</div>
              <div className="result-details">
                <UserOutlined />
                {interaction.customer?.fullname} /
                <CalendarOutlined />{" "}
                {moment(interaction.activityDate, "YYYY-MM-DD HH:mm:ss").format(
                  "DD/MM/YYYY",
                )}{" "}
                / {interaction.interactionSource.name} /{" "}
                {interaction.status === "OPEN" ? (
                  <Tag color="blue">Open</Tag>
                ) : (
                  <Tag color="red">Closed</Tag>
                )}
              </div>
            </div>
            <span className="right-arrow">→</span>
          </div>
        ))
      )}
    </div>
  );
}
